import * as React from 'react';
import * as FileExtensions from '../FileExtensions';
import { Translate } from '../../../../shared/LanguageService';
import { Button, ButtonGroup } from 'react-bootstrap';
import { IImageFile } from '../Entities';
import unknownIcon from '../../../../assets/images/mystery-file-icon.svg';
import pdfIcon from '../../../../assets/images/pdf-icon.svg';
import skpIcon from '../../../../assets/images/skp-icon.svg';
import psdIcon from '../../../../assets/images/psd-icon.svg';

interface IProps {
    file: IImageFile;
    readOnly: boolean;
    forAgent: boolean;
    user: any;
    onClick: () => void;
    onAnnotate?: () => void;
    onDelete?: () => void;
    downloadTranslationKey: string;
    annotateButtonTranslationKey?: string;
    hideFilename?: boolean;
}

const ExternalImageFile = (props: IProps) => {
    const anyActiveButtons = () => {
        return (
            (props.file.fileType !== FileExtensions.jpg &&
                props.file.fileType !== FileExtensions.png) ||
            (!props.readOnly &&
                ((props.onAnnotate &&
                    (props.file.fileType === FileExtensions.jpg ||
                        props.file.fileType === FileExtensions.png) &&
                    props.annotateButtonTranslationKey) ||
                    (props.onAnnotate &&
                        (props.file.fileType === FileExtensions.jpg ||
                            props.file.fileType === FileExtensions.png) &&
                        !props.annotateButtonTranslationKey) ||
                    props.onDelete))
        );
    };

    if (!props.file) {
        return null;
    }

    let styleNoBorder = { border: 'none' };

    const { apiUrl } = window.appConfig;

    return (
        <fieldset style={styleNoBorder}>
            <legend></legend>
            <div className="button-bar-below">
                {props.hideFilename ? null : <p className="limit-width">{props.file.filename}</p>}
                <div className="content-row">
                    {props.file.fileType === FileExtensions.unknown && (
                        <img className="pdf-icon" src={unknownIcon} />
                    )}
                    {props.file.fileType === FileExtensions.pdf && (
                        <img className="pdf-icon" src={pdfIcon} />
                    )}
                    {props.file.fileType === FileExtensions.psd && (
                        <img className="pdf-icon" src={psdIcon} />
                    )}
                    {props.file.fileType === FileExtensions.skp && (
                        <img className="pdf-icon" src={skpIcon} />
                    )}
                    {(props.file.fileType === FileExtensions.jpg ||
                        props.file.fileType === FileExtensions.png) && (
                        <img
                            onClick={props.onClick}
                            src={`${apiUrl}/file/${props.file.thumbnailReference}`}
                        />
                    )}
                </div>
                {anyActiveButtons() && (
                    <div className="button-row">
                        <ButtonGroup bsSize="sm" className="buttons-center">
                            {props.file.fileType !== FileExtensions.jpg &&
                                props.file.fileType !== FileExtensions.png && (
                                    <div>
                                        {props.forAgent && (
                                            <a
                                                className="btn btn-default"
                                                href={`${apiUrl}/file/${props.file.fileReference}`}
                                                target="_blank"
                                            >
                                                {Translate(
                                                    'order/plan/delivery/download-file/agent'
                                                )}
                                            </a>
                                        )}
                                        {!props.forAgent && (
                                            <a
                                                className="btn btn-info"
                                                title={Translate(props.downloadTranslationKey)}
                                                href={`${apiUrl}/file/${props.file.fileReference}`}
                                                target="_blank"
                                            >
                                                <i className="material-icons md-18">
                                                    cloud_download
                                                </i>
                                            </a>
                                        )}
                                    </div>
                                )}

                            {!props.readOnly && (
                                <div>
                                    {props.onAnnotate &&
                                        (props.file.fileType === FileExtensions.jpg ||
                                            props.file.fileType === FileExtensions.png) &&
                                        props.annotateButtonTranslationKey && (
                                            <Button onClick={props.onAnnotate} bsStyle="success">
                                                {Translate(props.annotateButtonTranslationKey)}
                                            </Button>
                                        )}
                                    {props.onAnnotate &&
                                        (props.file.fileType === FileExtensions.jpg ||
                                            props.file.fileType === FileExtensions.png) &&
                                        !props.annotateButtonTranslationKey && (
                                            <Button
                                                bsStyle="info"
                                                title={Translate(
                                                    'order/plan/delivery-file/annotate-button'
                                                )}
                                                onClick={props.onAnnotate}
                                            >
                                                <i className="material-icons no-label">mode_edit</i>
                                            </Button>
                                        )}
                                    {props.onDelete && props.forAgent && (
                                        <Button bsStyle="danger" onClick={props.onDelete}>
                                            {Translate('order/plan/delivery-file/delete-button')}
                                        </Button>
                                    )}
                                    {props.onDelete && !props.forAgent && (
                                        <Button
                                            bsStyle="danger"
                                            title={Translate(
                                                'order/plan/delivery-file/delete-button'
                                            )}
                                            onClick={props.onDelete}
                                        >
                                            <i className="material-icons no-label md-18">
                                                delete_forever
                                            </i>
                                        </Button>
                                    )}
                                </div>
                            )}
                        </ButtonGroup>
                    </div>
                )}
            </div>
        </fieldset>
    );
};

export default ExternalImageFile;
